import { createContext, useContext, useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { watchAdminAuth } from "lib/adminAuth";
export const AdminContext = createContext(null);
export const useAdmin = () => useContext(AdminContext);
export const hasCapability = (profile, cap) =>
  profile?.capabilities?.includes("*") || profile?.capabilities?.includes(cap);
export default function RequireAdmin({ children }) {
  const [state, setState] = useState({ status: "checking" });
  useEffect(() => {
    let alive = true,
      unsubscribe;
    const previousTitle = document.title;
    const robots = document.head.querySelector('meta[name="robots"]');
    const oldRobots = robots?.content;
    const meta = robots || document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow";
    if (!robots) document.head.appendChild(meta);
    document.title = "Magellan Admin";
    const update = (next) => {
      if (alive) setState(next);
    };
    try {
      unsubscribe = watchAdminAuth(update);
    } catch (error) {
      update({ status: "error", error });
    }
    return () => {
      alive = false;
      unsubscribe?.();
      document.title = previousTitle;
      if (robots) robots.content = oldRobots;
      else meta.remove();
    };
  }, []);
  if (window.location.hash.startsWith("#invitation="))
    return <Navigate to={"/admin/invitation" + window.location.hash} replace />;
  if (state.status === "signed_out")
    return <Navigate to="/admin/login" replace />;
  if (state.status === "authorized")
    return (
      <AdminContext.Provider value={state.profile}>
        {children}
      </AdminContext.Provider>
    );
  return (
    <div className="min-h-screen bg-canvas text-ink flex items-center justify-center p-8">
      <div className="max-w-xl border border-gold/20 p-8">
        <h1 className="font-display text-3xl">
          {state.status === "checking"
            ? "Checking admin access…"
            : "Admin access unavailable"}
        </h1>
        <p className="my-6" role="status">
          {state.error?.message || "Verifying your current permissions."}
        </p>
        {state.status !== "checking" && (
          <Link className="text-accent-ink underline" to="/admin/login">
            Return to sign in
          </Link>
        )}
      </div>
    </div>
  );
}
